import loadable from '@loadable/component';

export const LoadableSwiperSlider = loadable(
  () => import(/* webpackChunkName: "SwiperSlider" */ './SwiperSlider'),
);
